module.exports = __webpack_public_path__ + "img/americanexpress.01566307.png";